import { useEffect } from 'react';
import './loader.css';
export const LogoLoader = () => {
  useEffect(() => {
    Array.from(document.getElementsByClassName('path')).forEach(
      (pathElement: any) => {
        const svgPathElement = pathElement as SVGPathElement;
        const length = svgPathElement.getTotalLength();
        svgPathElement.style.strokeDasharray = `${length}`;
        svgPathElement.style.strokeDashoffset = `${length}`;
      }
    );
  }, []);
  return (
    <div className='logo-loader-ampwise'>
      <svg
        version='1.1'
        id='Layer_1'
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 -0 100 100'
        className='rotate-logo-svg'
        xmlSpace='preserve'
      >
        <g
          transform='translate(10.000000, 5.000000) scale(0.2)'
          fill='#FDB913'
          stroke='#FDB913'
        >
          <path
            className='path path1'
            d='M135.5,102h5c1.5,0,3.3-1,4.1-2.4l17.1-29l-3.9,28c-0.1,0.9,0.1,1.7,0.7,2.4c0.5,0.6,1.3,1,2.2,1h7.3
	c1.7,0,3.2-1.3,3.4-3l7.4-55.7c0.1-0.9-0.1-1.7-0.7-2.3 M141,80.5c-0.1,0.2-0.2,0.4-0.3,0.5l-12.9-38.4c-0.5-1.5-2.1-2.6-3.7-2.6h-9
	c-1.7,0-3.2,1.3-3.4,3l-7.1,55.7c-0.1,0.8,0.1,1.7,0.7,2.3c0.5,0.6,1.5,1,2.4,1h7.2c1.7,0,3.2-1.3,3.4-3l3.8-28.9 M178.2,41
	c-0.6-0.6-1.4-1-2.2-1h-8.3'
          />
          {/* <path
            className='path path2'
            d='M369.9,172.9c-12.2,0-20.4-2.9-25.5-13.5v42.9c-4.2,0-15.4,0.7-19.2-2.4c-2.5-2-3-5.7-3-13.7V87.1
		c17.7,0,17.7,0,17.7,10.3c6.1-6.2,14.9-11.3,29.7-11.3c29.5,0,38,21.3,38,43.4C407.6,151.6,399.5,172.9,369.9,172.9z M385.1,129.5
		c0-15.9-3.9-25-20.3-25c-20.9,0-20.9,0.2-20.9,25c0,15.2,3,24.7,20.6,24.7c20.8,0,20.4-0.2,20.4-24.7H385.1z'
          />
          <path
            className='path path3'
            d='M569.6,78.7c-8.1,0-15.5-2.5-15.5-12.5c0-10.3,7.1-12.5,15.5-12.5c8.1,0,14.9,2.4,14.9,12.5
		C584.5,76.2,577.7,78.7,569.6,78.7z M558.7,153.8V87.5c4.4,0,15.4-0.7,19.2,2.4c2.5,2,3,5.7,3,13.7v66.7
		C560.2,170.2,558.7,169.4,558.7,153.8z'
          />
          <path
            className='path path4'
            d='M628.2,170.4h-32.4c0-3.5-0.8-12.3,2.4-15.5c1.9-1.9,5.7-2.2,13.3-2.2h16.2c2.5,0,14.2,0.3,16.4-0.7
		c1.3-0.3,1-6.4,1-7.3c0-5.7-11.1-8.1-15.5-8.9c-15-3-34.4-3.7-34.8-23.5c-0.5-15.7,12.3-25.2,38.7-25.2h29.4
		c0,3.7,0.8,12.2-2.2,15.4c-1.9,1.9-5.6,2.2-13,2.2h-14.7c-2.2,0-13.2-0.2-15.2,0.7c-1.2,0.7-0.7,7.3-0.7,8.3c0,1.7,1.3,3.9,6.8,5.6
		c16.7,4.7,43.4,3,43.4,26.7C667.2,159.2,655,170.4,628.2,170.4z'
          />
          <path
            className='path path5'
            d='M743.2,135.4h-40.7c0,10.5,7.6,17.2,20.4,17.2h18.2c15,0,16,1,16,17.7h-33.6c-34.6,0-43.7-20.3-43.7-41.9
		c0-21.8,9.3-42.4,44.1-42.4c26.7,0,39.8,16,39.8,36.1C763.8,136.9,761.9,135.4,743.2,135.4z M722.4,103.5c-19.4,0-19.9,0-19.9,17.9
		h39C741.5,110.6,733.9,103.5,722.4,103.5z'
          />
          <path
            className='path path6'
            d='M435.6,158.8l3.6,11.4c12.2,0,17.2-0.2,20.4-2c4.2-2.7,5.9-8.9,7.1-13.2l12.8-41.4l17.7,56.6
		c12.8,0,18.1-0.2,21.3-2c4.6-2.7,5.9-8.9,7.3-13.2l21.8-67.9c-23.3,0-24.5,2-28.2,15.5l-11,42.4l-13.5-42.4
		c-1.2-4.2-2.9-10.6-6.9-13.3c-2.9-2-7.4-2.2-18.9-2.2l-17.6,57.1l-10.1-41.5c-1-4.2-2-10.8-6.4-13.5c-4.3-2.7-15.6-2.1-21-2
		L435.6,158.8z'
          />
          <path
            className='path path7'
            d='M151,156.7c-5.7,9.5-16.2,14.4-29.7,14.4c-18.2,0-35.1-7.8-35.1-26.2c0-17.4,11.6-25,37.1-25h23.5
		c0-11.6-6.2-14.5-20.1-14.5h-16.9c-14.5,0-15.2-1.2-15.2-17.9h31.6c34.3,0,42.9,13.8,42.9,36v46.8C151.5,170.2,151,170,151,156.7z
		 M126,133.6c-16.2,0-16.9,0.2-16.9,11.1c0,5.2,4.2,8.9,16.2,8.9c21.4,0,21.4-0.5,21.4-19.9L126,133.6z'
          /> */}
        </g>
      </svg>
    </div>
  );
};
